
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("bEZKb", function(module, exports) {

$parcel$export(module.exports, "NoPermissionViews", () => $c2689c9e4184dc1c$export$216f698de6226364);

var $aPvoy = parcelRequire("aPvoy");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $360jD = parcelRequire("360jD");

var $5ktoC = parcelRequire("5ktoC");
const $c2689c9e4184dc1c$export$216f698de6226364 = ({ dataRef: dataRef })=>{
    const data = (0, $iWLL0.useFragment)((0, $aPvoy.default), dataRef);
    const canCreateProject = data?.jira?.canCreateProject;
    return data?.jira && canCreateProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ktoC.NoProjects), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $360jD.NoPermissions), {
        dataRef: data
    });
};

});
parcelRegister("aPvoy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee009f5245c86382$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fdda3907d2591b05ec476be1c802c405>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ee009f5245c86382$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "noPermissionViews_projectsDirectoryV3",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "noPermissions_projectsDirectoryV3"
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "alias": "canCreateProject",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ]
        }
    ],
    "type": "Query"
};
$ee009f5245c86382$var$node.hash = "788b343e3e8a65ae1b059245a8e7e41c";
var $ee009f5245c86382$export$2e2bcd8739ae039 = $ee009f5245c86382$var$node;

});

parcelRegister("360jD", function(module, exports) {

$parcel$export(module.exports, "NoPermissions", () => $a1621868e4b5dec0$export$77ab0657ce145d4);

var $ftb5X = parcelRequire("ftb5X");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gd0Sp = parcelRequire("gd0Sp");

var $b6Xge = parcelRequire("b6Xge");

var $8mcY8 = parcelRequire("8mcY8");

var $drHER = parcelRequire("drHER");
const $a1621868e4b5dec0$var$PrimaryActionButton = ({ canManagePermissions: canManagePermissions, canContactAdmins: canContactAdmins })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (canManagePermissions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        href: "/secure/admin/ViewPermissionSchemes.jspa"
    }, formatMessage((0, $8mcY8.default).buttonAdmin));
    if (canContactAdmins) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        href: "/secure/ContactAdministrators!default.jspa"
    }, formatMessage((0, $8mcY8.default).buttonUser));
    return null;
};
const $a1621868e4b5dec0$export$77ab0657ce145d4 = ({ dataRef: dataRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { jira: jira } = (0, $iWLL0.useFragment)((0, $ftb5X.default), dataRef);
    const canManagePermissions = tenantContext?.isAdmin;
    const canContactAdmins = (0, $eUqFw.useMemo)(()=>jira?.canContactAdmin?.find(({ key: key })=>key === 'jira.show.contact.administrators.form')?.value === 'true', [
        jira?.canContactAdmin
    ]);
    const newDesc = canManagePermissions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $8mcY8.default).instructionsAdmin)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $drHER.SignInRedirect), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        width: "narrow",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b6Xge))),
        header: formatMessage((0, $8mcY8.default).header),
        description: newDesc,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1621868e4b5dec0$var$PrimaryActionButton, {
            canManagePermissions: canManagePermissions,
            canContactAdmins: canContactAdmins
        })
    });
};

});
parcelRegister("ftb5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $c30dd82a2ce39c5b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7f31fc03c816578a8cde0e9498ff41d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c30dd82a2ce39c5b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "noPermissions_projectsDirectoryV3",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "alias": "canContactAdmin",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "keys",
                            "value": "jira.show.contact.administrators.form"
                        }
                    ],
                    "concreteType": "JiraApplicationProperty",
                    "kind": "LinkedField",
                    "name": "applicationPropertiesByKey",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$c30dd82a2ce39c5b$var$node.hash = "824d62f023722651098b2c7e7b3f2e7b";
var $c30dd82a2ce39c5b$export$2e2bcd8739ae039 = $c30dd82a2ce39c5b$var$node;

});

parcelRegister("b6Xge", function(module, exports) {
module.exports = new URL("empty.e3c28025.svg", import.meta.url).toString();

});

parcelRegister("8mcY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $219ef87b31e77f13$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$219ef87b31e77f13$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "projects-directory-v3.page-layout.no-permission-views.no-permissions.header",
        "defaultMessage": "You can't access any projects or issues"
    },
    instructionsAdmin: {
        "id": "projects-directory-v3.page-layout.no-permission-views.no-permissions.instructions-admin",
        "defaultMessage": "You don't have the sufficient permissions. The permission can be changed in the project's permission scheme."
    },
    instructionsUser: {
        "id": "projects-directory-v3.page-layout.no-permission-views.no-permissions.instructions-user",
        "defaultMessage": "Try logging in. If you're already logged in, ask a Jira admin to change your permissions."
    },
    buttonAdmin: {
        "id": "projects-directory-v3.page-layout.no-permission-views.no-permissions.button-admin",
        "defaultMessage": "Open permission schemes"
    },
    buttonUser: {
        "id": "projects-directory-v3.page-layout.no-permission-views.no-permissions.button-user",
        "defaultMessage": "Contact administrators"
    }
});

});

parcelRegister("drHER", function(module, exports) {

$parcel$export(module.exports, "SignInRedirect", () => $a530473087c39d34$export$49e85916e94ff0b7);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $d3bTi = parcelRequire("d3bTi");

var $dxJ2e = parcelRequire("dxJ2e");
const $a530473087c39d34$export$49e85916e94ff0b7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $dxJ2e.default).signIn,
        values: {
            // @ts-expect-error - Type '(msg: string) => JSX.Element' is not assignable to type 'ReactNode'.
            link: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d3bTi.default), {
                    to: `/login.jsp?os_destination=${window.location.href}`
                }, msg)
        }
    });

});
parcelRegister("dxJ2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $88ae546a1055899d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $88ae546a1055899d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    signIn: {
        "id": "projects-directory-v3.page-layout.no-permission-views.no-permissions.sign-in-redirect.sign-in",
        "defaultMessage": "<link>Try logging in.</link> If you're already logged in, ask a Jira admin to change your permissions."
    }
});

});



parcelRegister("5ktoC", function(module, exports) {

$parcel$export(module.exports, "NoProjects", () => $0980994aea48e924$export$f75f7940f9cdc438);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lbttE = parcelRequire("lbttE");

var $ciFaF = parcelRequire("ciFaF");

var $gtXvi = parcelRequire("gtXvi");
const $0980994aea48e924$export$f75f7940f9cdc438 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'emptyView'
    });
    const handleCreate = (0, $eUqFw.useCallback)((open)=>{
        open({
            isNextGen: false,
            showExperienceSelection: false
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'CreateProjectButton');
    }, [
        analyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbttE.ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
            width: "narrow",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ciFaF))),
            header: formatMessage((0, $gtXvi.default).header),
            description: formatMessage((0, $gtXvi.default).description),
            primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "primary",
                onClick: ()=>handleCreate(open)
            }, formatMessage((0, $gtXvi.default).createProject))
        }));
};

});
parcelRegister("ciFaF", function(module, exports) {
module.exports = new URL("empty.e3c28025.svg", import.meta.url).toString();

});

parcelRegister("gtXvi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c91872ef3a9a217$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2c91872ef3a9a217$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "projects-directory-v3.page-layout.no-permission-views.no-projects.header",
        "defaultMessage": "You currently have no projects"
    },
    description: {
        "id": "projects-directory-v3.page-layout.no-permission-views.no-projects.description",
        "defaultMessage": "Let's create your first project in Jira"
    },
    createProject: {
        "id": "projects-directory-v3.page-layout.no-permission-views.no-projects.create-project",
        "defaultMessage": "Create project"
    }
});

});




//# sourceMappingURL=async-project-directory-no-permission-views.dee68062.js.map
